<template>
  <div>
    <!-- 活动列表 -->
    <div class="line">
      <div class="flex">
        <v-select
          :options="options"
          v-model="params.status"
          placeholder="状态"
          class="item"
        />
        <vs-input
          class="item"
          v-model="params.activityName"
          placeholder="活动名称/编号"
        />
        <vs-button @click.prevent="getTableData">
          查询
        </vs-button>
      </div>
    </div>
    <vs-table :data="tableData" noDataText="暂无数据" class="main-table">
      <template slot="thead">
        <vs-th v-for="(headData, index) in headData" :key="index" >
          {{ headData }}
        </vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            {{ indextr  + 1}}
          </vs-td>

          <vs-td :data="tr.id">
            {{ tr.id }}
          </vs-td>

          <vs-td :data="tr.activityName">
            {{ tr.activityName }}
          </vs-td>

          <vs-td>
            {{ tr.type | getType }}
          </vs-td>

          <vs-td> {{ tr.createTime }} </vs-td>

          <vs-td> {{ tr.userNum }} ／ {{ tr.storeNum }} </vs-td>

          <!-- <vs-td :data="tr.status">
            {{ tr.status | getStatus }}
          </vs-td> -->

          <vs-td>
            <vs-button
              color="primary"
              type="flat"
              @click="detail(data[indextr])"
            >
              查看
            </vs-button>
            <vs-button v-if="filtering('storeactivities:entrance:export')" color="primary" type="flat" @click="exportExcel(tr)">
              导出
            </vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <!-- <vs-pagination v-if="tableData.length" class="pagination" :total="pagination.totalPage" v-model="pagination.page" :max-items="pagination.size" :goto="true"></vs-pagination> -->
    <gc-vs-pagination
      v-if="tableData.length"
      :pager="pagination"
      pageSizeName="pageSize"
      totalName="totalPage"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      ></gc-vs-pagination>
  </div>
</template>

<script>
import { DistributionApi } from "@/modules/server-api/commodity-sys/distribution.ts";
import constants from "../../../constants.ts";
import { Http } from "@/h5_src/network/http";
import {ServerDistApi} from "../../../../../group-cloud/network/ServerBizApi";
import moment from 'moment'


export default {
  props:{
    pageSize:{
      default:20,
      type: Number
    }
  },
  data() {
    return {
      params: { activityName: "", page: 0, size: 10, id: "" },
      options: [
        { label: "关闭", code: 2 },
        { label: "开启", code: 1 }
      ],
      headData: [
        "序号",
        "编号",
        "名称",
        "类型",
        "创建时间",
        "参与/覆盖",
        // "状态",
        "操作"
      ],
      tableData: [],
      pagination: {
        totalPage: 1,
        page: 1,
        pageSize: this.pageSize
      },
    };
  },
  filters: {
    getStatus(val) {
      console.log('233333',val)
      let text = "--";
      switch (val) {
        case 1:
          text = "关闭";
          break;
        case 2:
          text = "开启";
      }
      return text;
    },
    getType(val) {
      const item = constants.typeOptions.find(({ value }) => value === val) || {};
      return item.label;
    }
  },
  watch: {
      // 'pagination.page'() {
      //     this.getTableData();
      // }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
       this.$vs.loading();
      const { code = 0 } = this.params.status || {};
      DistributionApi.activityConfigList({
        ...this.params,
        page: this.pagination.page - 1,
        size: this.pagination.pageSize,
        status: code,
        type: [1,2,3],    // 1=宣传/2=核销/3=报名
        id: this.params.activityName
      }).then(({ result = {} }) => {
        const { data = [], totalPage, totalElements } = result;
        this.tableData = data.map(item => {
          return {
            ...item,
            createTime: moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
          }
        });
        //this.pagination.totalPage = totalPage
        this.pagination.totalPage = totalElements
       this.$vs.loading.close();
      });
    },


    detail({ id = "" }) {
      const path = `storeactivities/record/${id}`;
      this.$router.push({ path });
    },
    saveDate(val) {
      this.params.date = val;
    },
    async exportExcel(record) {
       // let syncResponse = await Http.getHandler().get('/data-dist/api/dist/userActivity/getDetailExcel', {
       //          params: {configId:id}
       //      },{ responseType: "blob" });
      let syncResponse = await DistributionApi.getDetailExcel_2({configId:record.id});

      // let filename = `UserActivity-${id}.xlsx`;
      const filename = record.activityName + '.xlsx';

      console.log(['export', syncResponse]);
        if (syncResponse.result && syncResponse.result.blob) {
          const link = document.createElement("a");
          link.style.display = "none";
          let URL = window.URL || window.webkitURL;
          link.href = URL.createObjectURL(syncResponse.result.blob);
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          // 释放的 URL 对象以及移除 a 标签
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }
    },
    //更改每页条数
    handleSizeChange(val){
      this.pagination.pageSize = val;
      this.$emit("changePageSize", val);
      this.getTableData();
    },
    handleCurrentChange(val){
      this.pagination.page = val;
      this.getTableData();
    }
  }
};
</script>

<style scoped >
.line {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}
.item {
  margin-right: 10px;
  width: 200px;
}
.none {
  opacity: 0;
}

  .main-table th {
    min-width: 60px;

  }

.vs-button {
    padding: 5px 8px !important;
  }
</style>
